export const DELIVERY = 'DELIVERY'
export const PAYMENT = 'PAYMENT'